import React, { FunctionComponent } from 'react';

import { Footnotes } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import usePalette from '@gojob/ui-bits/styles/PaletteProvider/usePalette';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import { graphql } from 'gatsby';

import BreakpointContainer from '../../BreakpointContainer';
import BlockRenderer from '../../Section/FootNotes/BlockRenderer';

export const FootNotesFragment = graphql`
  fragment FootNotesFragment on SanityFootNotes {
    notes {
      _rawContent
    }
    variant {
      variant
    }
  }
`;

const FootNotes: FunctionComponent<Footnotes> = (props) => {
  const { notes = [] } = props;
  const {
    typography: { accent },
  } = usePalette();
  const { colors } = useTheme();

  return (
    <BreakpointContainer maxWidth="xl" margin={4}>
      {notes.map((note, i) => {
        return (
          <Flex css={{ whiteSpace: 'pre-wrap' }} margin={[0, 0, 1]} key={i}>
            <Text variant="message4" color={colors[accent]}>
              {Array(i + 2).join('*')}{' '}
            </Text>
            <BlockRenderer blocks={note._rawContent} />
          </Flex>
        );
      })}
    </BreakpointContainer>
  );
};

export default FootNotes;
